import { keepPreviousData, useMutation, useQuery } from '@tanstack/react-query'

import { queryClient } from '@/lib/queryClient'

import { meusEventosApi } from '../api/meusEventosApi'
import type { MeuEventoListFilters } from '../types/meuEvento'

export const meusEventosKeys = {
  all: ['meus-eventos'] as const,
  lists: () => [...meusEventosKeys.all, 'list'] as const,
  list: (filters: MeuEventoListFilters) => [...meusEventosKeys.lists(), filters] as const,
}

export function useMeusEventos(filters: MeuEventoListFilters) {
  return useQuery({
    queryKey: meusEventosKeys.list(filters),
    queryFn: () => meusEventosApi.list(filters),
    placeholderData: keepPreviousData,
  })
}

/** Idempotente — sem toast, só reflete o estado de "visualizado" na lista. */
export function useMarcarEventoVisualizado() {
  return useMutation({
    mutationFn: (id: string) => meusEventosApi.marcarVisualizado(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: meusEventosKeys.lists() })
    },
  })
}
